import PropTypes from 'prop-types'

const Link = ({ to, target, rel, onClick, children }) => {
  let sanitizedLink = to
  if (sanitizedLink?.indexOf('internal:') === 0) {
    sanitizedLink = sanitizedLink.replace('internal:', '')
  }

  return (
    <a
      tabIndex={0}
      href={sanitizedLink}
      target={target}
      rel={rel}
      onClick={(e) => {
        if (onClick) {
          onClick(e)
        }
      }}
    >
      {children}
    </a>
  )
}

Link.propTypes = {
  to: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
}

export default Link
